<template>
  <div class="box">
    <div style="display: flex;height: 100%;">
      <div class="pay-left">
        <p class="active">在线充值</p>
        <p>在线充值</p>
        <p>充值查询</p>
        <p>充值帮助</p>
        <p>温馨提示</p>
      </div>
      <div class="pay-right">
        <div>
          <p class="title">在线充值</p>
          <p class="line"></p>
        </div>
        <div class="form">
          <div class="item">
            <p class="item-title">用户名：</p>
            <input type="text" />
          </div>
          <div class="item">
            <p class="item-title">账号：</p>
            <input type="text" />
          </div>
          <div class="item">
            <p class="item-title">密码：</p>
            <input type="text" />
          </div>
          <div class="item">
            <p class="item-title">确认密码：</p>
            <input type="text" />
          </div>
          <div class="item">
            <p class="item-title">充值金额：</p>
            <div class="price">
              <div>
                <input type="radio" name="price" />
                10元
              </div>
              <div>
                <input type="radio" name="price" />
                30元
              </div>
              <div>
                <input type="radio" name="price" />
                50元
              </div>
              <div>
                <input type="radio" name="price" />
                其它
              </div>
            </div>
          </div>
          <div class="item">
            <p class="item-title">充值方式：</p>
            <div class="way-box">
              <p
                v-for="(item, index) in tabList"
                :key="index"
                @click="change(index)"
                :class="{ current: tabIndex === index }"
              >
                {{ item }}
              </p>
            </div>
          </div>
          <img
            src="https://moyi-uccn.oss-cn-beijing.aliyuncs.com/pay_ewm.svg"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 底部-->
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  name: "Pay",
  components: {
    Footer,
  },
  data() {
    return {
      tabList: ["支付宝", "网上银行", "财付通"],
      tabIndex: 0,
    };
  },
  mounted() {
    console.log("222222222222222*************");
    // location.reload()
  },
  methods: {
    change(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  // height: 100%;
  .pay-left {
    width: 298px;
    // height: 100%;
    background: #f2f4fe;
    padding-top: 84px;
    p {
      width: 100%;
      height: 64px;
      text-align: center;
      line-height: 64px;
      font-weight: bold;
      color: #000;
    }
    .active {
      background: #3662ec;
      color: #fff;
    }
  }
  .pay-right {
    background: #fff;
    width: 100%;
    padding-top: 105px;
    .title {
      padding-left: 45px;
    }
    .line {
      width: 100%;
      height: 1px;
      border: 2px solid #d4d4d4;
    }
    .form {
      padding-left: 200px;
      padding-top: 75px;
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .item-title {
          width: 120px;
          text-align: right;
          font-weight: bold;
          margin-right: 30px;
        }
        .way-box {
          display: flex;
          align-items: center;
          p {
            width: 126px;
            height: 23px;
            border-radius: 3px;
            box-sizing: border-box;
            border: 2px solid #3662ec;
            text-align: center;
            line-height: 20px;
            margin-right: 36px;
            font-size: 14px;
          }
          .current {
            background: #3662ec;
            color: #fff;
          }
        }
        input[type="text"] {
          width: 469px;
          height: 32px;
          border-radius: 7px;
          background: #e9ecff;
          border: none;
        }
        .price {
          display: flex;
          align-items: center;
          position: relative;
          top: -5px;
          div {
            display: flex;
            align-items: center;
            margin-right: 30px;
            input {
              margin: 0;
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
